// Vendor Libs
import React, { useEffect } from 'react';
import PropTypes from 'prop-types'; // Dish Tech React

import { useOverlay, useService } from '@dishtech-react/hooks'; // Material UI

import { CircularProgress } from '@material-ui/core'; // Components

import { Overlay } from './overlay';
export var Loading = function Loading(_ref) {
  var serviceKey = _ref.serviceKey;

  var _useService = useService(serviceKey),
      fetching = _useService.fetching;

  var _useOverlay = useOverlay({
    title: 'loading'
  }),
      closeOverlay = _useOverlay.closeOverlay,
      openOverlay = _useOverlay.openOverlay,
      overlayId = _useOverlay.overlayId;

  useEffect(function () {
    if (fetching) {
      openOverlay();
    } else {
      closeOverlay();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [fetching]);
  return /*#__PURE__*/React.createElement(Overlay, {
    id: overlayId
  }, /*#__PURE__*/React.createElement(CircularProgress, null));
};
Loading.propTypes = {
  serviceKey: PropTypes.string.isRequired
};